import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';

import { AuthService } from '../../services/auth.service';
import { ErrorService } from '../../services/error.service';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  // Show/Hide dialog popups
  showLoginDialog = false;
  showRegisterDialog = false;
  showNewStudentPasswordDialog = false;
  showForgotUsernameDialog = false;
  showForgotPasswordDialog = false;
  // Login dialog popup
  loginInfo = {
    loginId: '',
    password: ''
  };
  loginIdFormControl = new FormControl('', [
    Validators.required,
  ]);
  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  loginErrors = [];
  // Register dialog popup
  newStudent = {};
  newStudentAccessCodeErrors = '';
  newStudentPasswordErrors = '';
  registerAccessCodeFormControl = new FormControl();
  registerAccessCode = '';
  registerPasswordFormControl = new FormControl();
  registerPassword = '';
  registerPasswordConfirmFormControl = new FormControl();
  registerPasswordConfirm = '';
  // Forgot username
  forgotUsernameEmail = '';
  forgotUsernameErrors = [];
  // Forgot password
  forgotPasswordUserId = '';
  forgotPasswordErrors = [];



  constructor(private router: Router, private http: HttpClient, private afAuth: AngularFireAuth, private afd: AngularFireDatabase, public authService: AuthService, public errorService: ErrorService) {
    // If there is already a user, the AuthState will change... it goes from NotAuthed -> Yes Authed
    this.afAuth.auth.onAuthStateChanged(user => {
      // When that AuthState changes, check if there is a user
      if (user) {
        // Assign userBasicInfo$ to the obervable from Firebase, and subscribe to it
        // When we get an answer back, put that answer into an easily accessible variable
        this.authService.userBasicInfo$ = this.afd.object(`/userBasicInfo/${user.uid}`).valueChanges();
        this.authService.userBasicInfo$.subscribe(
          value => {
            value = value ? value : {};
            this.authService.userBasicInfoSaved = value;
            this.authService.userBasicInfoSaved['uid'] = user.uid
          },
          err => { console.log('error for userBasicInfo$:', err); },
          () => console.log('completed userBasicInfo$ subscribe inside ngAfterViewInit, inside header.component.ts')
        );
      } else {
        // There was no user, this must be a publically accessible page
        // We do NOT need to do anything here, any private routes will already be protected by the guards
        console.log('the constructor in header.component.ts says: no user... so sad.');
      }
    });
    // Show an internet status indicator on the toolbar
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    // We want to hide the header and footer on the create-login-link page... and show it on the rest of the pages
    this.router.events.subscribe( event => {
      if (event['url'] && event['url'].includes('create-login-link')) {
        this.authService.hideHeaderAndFooter = true;
      } else {
        this.authService.hideHeaderAndFooter = false;
      }
    });

  }



  ngOnInit() {
  }



  // Controls the connection indicator showing user whether they are online or not - uses the $efaGreen color
  updateOnlineStatus(event) {
    if (event.type === 'online') {
      document.getElementById('onlineIndicator').hidden = false;
      document.getElementById('onlineIndicator').style.backgroundColor = '#8ACFBA';
    }
    else if (event.type === 'offline') {
      document.getElementById('onlineIndicator').hidden = false;
      document.getElementById('onlineIndicator').style.backgroundColor = 'red';
    }
    else {
      document.getElementById('onlineIndicator').hidden = true;
    }
  }



  // Called from the navbar login dialog popup, when Submit button is clicked
  loginUser() {
    // Reset the login error
    this.loginErrors = [];
    // Check if errors exist on the login form.
    if (this.loginIdFormControl.hasError('required') || this.passwordFormControl.hasError('required')) {
      // If so, stop the function.
      return;
    }
    this.errorService.showWorking('');
    // Login via authentication service
    this.authService.userLogin(this.loginInfo).then( () => {
      this.errorService.resetWorkingDialog();
      // On success, reset the login form
      this.resetLoginDialog();
      // Route them to their dashboard
      if (this.authService.userBasicInfoSaved['role'] === 'admin') {
        // Route to admin dashboard
        console.log('you are an admin, loginUser() inside header.component.ts is sending you to admin dashboard');
        this.router.navigateByUrl('admin');
      } else if (this.authService.userBasicInfoSaved['role'] === 'student') {
        // Route to student dashboard
        console.log('you are a student, loginUser() inside header.component.ts is sending you to student dashboard');
        this.router.navigateByUrl('student');
      } else {
        // Unknown role, log the user back out and force navigate home.
        console.log('you do not have a recognized role, loginUser() inside header.component.ts can not route to proper dashboard. Logging out instead...');
        this.errorService.showErrorMessage('You do not have a recognized role in the system - can not route to proper dashboard. Logging out instead...');
        this.authService.logout();
      }
    }).catch( err => {
      // Error kicked from userLogin function in the authService
      console.log('Error inside login function of header.component.ts:');
      console.log(err.message);
      this.loginErrors = err.message.match( /[^\.!\?]+[\.!\?]+/g );
      this.errorService.resetWorkingDialog();
    });
  }



  // Checks if the provided access code is a valid white-listed ID on the usersWhoNeedToSignUp table
  checkIfIdOnWhiteList() {
    this.errorService.showWorking('');
    this.afAuth.auth.signInWithEmailAndPassword(`${this.registerAccessCode.toUpperCase()}@elevenfifty.org`, 'student').then( initialLoginResponse => {
      // Save their info and show the popup
      this.afd.database.ref(`usersWhoNeedToSignUp/${initialLoginResponse.user.uid}`).once('value').then( valueOfUserInTableAsObject => {
        this.errorService.resetWorkingDialog();
        // Show popup asking for their password
        this.newStudent = valueOfUserInTableAsObject.val() ? valueOfUserInTableAsObject.val() : {};
        this.newStudent['key'] = initialLoginResponse.user.uid;
        this.registerAccessCode = '';
        this.newStudentAccessCodeErrors = '';
        this.showRegisterDialog = false;
        this.showNewStudentPasswordDialog = true;
      }).catch( err => { console.log('Error finding this uid in /usersWhoNeedToSignUp table, post-login'); console.log(err); this.errorService.showErrorMessage('Error finding this uid in /usersWhoNeedToSignUp table, after user login'); })
    }).catch( err => {
      // If they can still see the form, display an error
      this.newStudentAccessCodeErrors = 'Access code not found.';
      // Log the error just in case it's a weird one
      console.log(err);
    })
  }



  // Tries to register a new student
  signupNewStudent() {
    // Check if the password matches the passwordConfirm
    if (this.registerPassword !== this.registerPasswordConfirm) {
      // If not, stop the function.
      this.newStudentPasswordErrors = 'Passwords must match'
      return;
    }
    // Check if the password is the right length
    if (this.registerPassword.length < 6 || this.registerPassword.length > 20) {
      // If not, stop the function.
      this.newStudentPasswordErrors = 'Passwords must be between 6 and 20 characters.'
      return;
    }
    this.errorService.showWorking('');
    // Get the current admin's token, we will need to send that with the POST request
    this.afAuth.auth.currentUser.getIdToken().then( token => {
      // Prepare the object we're going to send
      const body = {
        accessToken: token,
        newPassword: this.registerPassword
      };
      // Send the post request to register this new student
      // Doing it this way, to the path /registerStudent instead of the full path, avoids CORS errors.
      // This path is set up in the firebase.json file to direct to the cloud function.
      // Meaning - this request WILL NOT WORK ON LOCAL HOST - it will only work when deployed to Firebase.
      this.http.post('/registerStudent', body).subscribe(
        resultTrueOrFalse => {
          if (!resultTrueOrFalse) {
            // If we receive 'false' as a response, it did not update the password - we need an admin to look at the logs and see why
            this.errorService.showErrorMessage('Failed to register user on backend. See Firebase cloud function logs for more details.');
          } else {
            // We received 'true' back, successfully created user
            this.registerPassword = '';
            this.registerPasswordConfirm = '';
            this.newStudentPasswordErrors = '';
            // If there is only 1 track for the student, set the recentStatus to be the status of that track
            this.newStudent['tracks'] = this.newStudent['tracks'] ? this.newStudent['tracks'] : {};
            // Initialize the default value of recentStatus
            let recentStatus = 'added';
            // If there is only 1 track assigned, save that status to be the recentStatus
            if (Object.keys(this.newStudent['tracks']).length === 1) {
              // Exactly 1 track assigned
              Object.keys(this.newStudent['tracks']).forEach( eachTrack => {
                recentStatus = this.newStudent['tracks'][eachTrack]['status']
              })
            }
            // Push the student's basic information into Firebase
            this.afd.object(`userBasicInfo/${this.newStudent['key']}`).set({
              idFromSis: this.newStudent['idFromSis'],
              email: this.newStudent['email'],
              firstName: this.newStudent['firstName'],
              lastName: this.newStudent['lastName'],
              role: this.newStudent['role'],
              recentStatus: recentStatus,
              recentStatusDate: this.newStudent['dateAdded']
            }).then( () => {
              // Push the track information into /studentTracks and into /trackStudents
              // First let's push it into /studentTracks, this lists the tracks for an individual student
              this.afd.object(`studentTracks/${this.newStudent['key']}`).set(this.newStudent['tracks']).then( () => {
                // Now, let's push into /trackStudents, this lists the students assigned to a particular track
                // Loop over the tracks assigned to this student
                Object.keys(this.newStudent['tracks']).forEach( eachTrack => {
                  this.afd.object(`trackStudents/${eachTrack}/${this.newStudent['key']}`).set({
                    status: this.newStudent['tracks'][eachTrack]['status'],
                    date: this.newStudent['tracks'][eachTrack]['date']
                  }).then( () => {
                    // Do nothing
                  }).catch( err => { console.log('Error adding student to /trackStudents inside signupNewStudent() inside header.component.ts'); console.log(err); this.newStudentPasswordErrors = err.message; });
                })
                // Now that we have iterated over the tracks, remove the user from /usersWhoNeedToSignUp
                this.afd.object(`usersWhoNeedToSignUp/${this.newStudent['key']}`).remove().then( () => {
                  this.errorService.resetWorkingDialog();
                  this.showNewStudentPasswordDialog = false;
                  this.router.navigateByUrl('student');
                }).catch( err => { console.log('Error deleting from /usersWhoNeedToSIgnUp inside signupNewStudent() inside header.component.ts'); console.log(err); this.newStudentPasswordErrors = err.message; });
              }).catch( err => { console.log('Error pushing new info into /studentTracks inside signupNewStudent() inside header.component.ts'); console.log(err); this.newStudentPasswordErrors = err.message; });
            }).catch( err => { console.log('Error pushing student info into /userBasicInfo inside signupNewStudent() inside header.component.ts'); console.log(err); this.newStudentPasswordErrors = err.message; });
          }
        },
        err => {
          console.log('error in POST request to register user, inside signupNewStudent(), inside header.component.ts.');
          console.log(err);
          this.errorService.showErrorMessage('Error in POST request to register user to our backend');
        },
        () => console.log('Completed POST request to register user, inside signupNewStudent(), inside header.component.ts.')
      )
    })
  }



  // Called when the login dialog popup is closed.
  resetLoginDialog() {
    // Erase any login error messages
    this.loginErrors = [];
    // Ensure the visibility-controlling variable is set to false
    this.showLoginDialog = false;
    // Empty and reset the login form
    this.loginIdFormControl.reset();
    this.loginIdFormControl.markAsPristine();
    this.loginIdFormControl.markAsUntouched();
    this.loginIdFormControl.updateValueAndValidity();
    this.passwordFormControl.reset();
    this.passwordFormControl.markAsPristine();
    this.passwordFormControl.markAsUntouched();
    this.passwordFormControl.updateValueAndValidity();
  }



  // Called from the Forgot Username popup, when the Submit button is pressed
  // Finds the user(s) associated with the email address and sends that email address an email containing their username(s) 
  forgotUsername() {
    // Check whether the form has been completed
    if (
      this.forgotUsernameEmail.trim() === ''
    ) {
      // If not, stop the function.
      this.forgotUsernameErrors.push('You must enter an email address.');
      return;
    }
    // Otherwise, proceed.
    this.errorService.showWorking('');
    // Clear any errors
    this.forgotUsernameErrors = [];
    // Display an "in progress" message
    this.forgotUsernameErrors.push('Working... please wait...');
    // We need to search the database for this email
    // Send the email address to the backend to handle this operation (database rules prevent our un-authed client from reading /userBasicInfo table)
    // Prepare the object we're going to send
    const body = {
      emailAddressToFind: this.forgotUsernameEmail.trim()
    };
    // Send the post request to update that user
    // Doing it this way, to the path /forgotUsername instead of the full path, avoids CORS errors.
    // This path is set up in the firebase.json file to direct to the cloud function.
    // Meaning - this request WILL NOT WORK ON LOCAL HOST - it will only work when deployed to Firebase.
    this.http.post('/forgotUsername', body).subscribe(
      data => {
        this.errorService.resetWorkingDialog();
        // If we receive 'false' as a response, it did not find a user with a matching email address
        if (!data) {
          // Clear any errors
          this.forgotUsernameErrors = [];
          // Display an "in progress" message
          this.forgotUsernameErrors.push('ERROR - Failed to find email address. Please contact an administrator.');
        } else {
          // Hide the popup
          this.forgotUsernameErrors = [];
          this.forgotUsernameEmail = '';
          this.showForgotUsernameDialog = false;
          alert(data['message']);
        }
      },
      err => { console.log('error in POST request to email the username to user, inside forgotUsername(), login.component.ts.'); console.log(err); this.errorService.showErrorMessage('Error in POST request to email the username to user'); },
      () => console.log('Completed POST request to email the username to user, inside forgotUsername(), login.component.ts.')
    )
  }



  // Called from the Forgot Password popup, when the Submit button is pressed
  // Finds the email address for the account with the given studentID and sends that email address an email containing a link to reset their password
  forgotPassword() {
    // Check whether the form has been completed
    if (
      this.forgotPasswordUserId.trim() === ''
    ) {
      // If not, stop the function.
      this.forgotPasswordErrors.push('You must enter a username.');
      return;
    }
    // Otherwise, proceed.
    this.errorService.showWorking('');
    // Clear any errors
    this.forgotPasswordErrors = [];
    // Display an "in progress" message
    this.forgotPasswordErrors.push('Working... please wait...');
    // We need to search the database for this email
    // Send the email address to the backend to handle this operation (database rules prevent our un-authed client from reading /userBasicInfo table)
    // Prepare the object we're going to send
    const body = {
      userIdToFind: this.forgotPasswordUserId.trim()
    };
    // Send the post request to update that user
    // Doing it this way, to the path /forgotPassword instead of the full path, avoids CORS errors.
    // This path is set up in the firebase.json file to direct to the cloud function.
    // Meaning - this request WILL NOT WORK ON LOCAL HOST - it will only work when deployed to Firebase.
    this.http.post('/forgotPassword', body).subscribe(
      data => {
        this.errorService.resetWorkingDialog();
        // If we receive 'false' as a response, it did not find a user with the given ID
        if (!data) {
          // Clear any errors
          this.forgotPasswordErrors = [];
          // Display an "in progress" message
          this.forgotPasswordErrors.push('ERROR - Failed to find account, or there is no email address for the account. Please contact an administrator.');
        } else {
          // Hide the popup
          this.forgotPasswordErrors = [];
          this.forgotPasswordUserId = '';
          this.showForgotPasswordDialog = false;
          alert(data['message']);
        }
      },
      err => { console.log('error in POST request to email reset link to user, inside forgotPassword(), login.component.ts.'); console.log(err); this.errorService.showErrorMessage('Error in POST request to email reset link to user'); },
      () => console.log('Completed POST request to email reset link to user, inside forgotPassword(), login.component.ts.')
    )
  }



}
